module.exports = __webpack_public_path__ + "static/media/eye.85890b89.svg";